import { call, fork, put, select, takeLatest } from "redux-saga/effects";
import { doFetchList, doFetchProb, doFetchTest, doPatchTestList } from "./api";
import { fetchList, fetchProb, fetchTest, moveTestAfter, moveTestBefore, setError, setOptions, setProbs, setTestList, TestState } from "./duck";
import { IOptions, IProblem, ITestList, ITestRaw } from "./types";
import { selectTest } from "./selectors";
import { useSelector } from "react-redux";

function* fetchTestWatcher() { yield takeLatest(fetchTest.type, fetchTestFlow) }
function* fetchProbWatcher() { yield takeLatest(fetchProb.type, fetchProbFlow) }
function* fetchListWatcher() { yield takeLatest(fetchList.type, fetchListFlow) }
function* patchListWatcher1() { yield takeLatest(moveTestAfter.type, patchListFlow) }
function* patchListWatcher2() { yield takeLatest(moveTestBefore.type, patchListFlow) }

function* fetchTestFlow(action: ReturnType<typeof fetchTest>){
    const test: ITestRaw = yield call(doFetchTest, action.payload)
    yield put(setError(test.error?test.error:''))
    if (test.success === false) {
        return
    }
    yield put(setProbs(test.tasks!))
    yield put(setOptions({owner: test.owner, public: test.public, info: test.info, title: test.title, description: test.description} as IOptions))
}

function* fetchProbFlow(action: ReturnType<typeof fetchProb>){
    const prob: IProblem = yield call(doFetchProb, action.payload)
    yield put(setError(prob.error?prob.error:''))
    if (prob.success === false) {
        return
    }
    yield put(setProbs([prob]))
}

function* fetchListFlow(action: ReturnType<typeof fetchList>){
    const {tests, options} = yield call(doFetchList)
    yield put(setError(''))
    yield put(setOptions(options))
    yield put(setTestList(tests))
    
}

function* patchListFlow(action: ReturnType<typeof moveTestAfter>){
    const state: TestState = yield select(selectTest)
    const data = state.testList.map((i) => i.id!)
    yield call(doPatchTestList, data)
}

export default function* sagas() {
    yield fork(fetchTestWatcher)
    yield fork(fetchProbWatcher)
    yield fork(fetchListWatcher)
    yield fork(patchListWatcher1)
    yield fork(patchListWatcher2)
}
  